import { render, staticRenderFns } from "./HaiBoTangOrderDetails.vue?vue&type=template&id=6fca247a&scoped=true"
import script from "./HaiBoTangOrderDetails.vue?vue&type=script&lang=js"
export * from "./HaiBoTangOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./HaiBoTangOrderDetails.vue?vue&type=style&index=0&id=6fca247a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca247a",
  null
  
)

export default component.exports